<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Assign Driver</h5>
      <button
        ref="modalCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <form @submit.prevent="assignDriver">
      <div class="modal-body">
        <template
          v-for="(requestRoute, index) in requestDetails.trip_request_routes"
          :key="index"
        >
          <div
            class="partner-modal-section"
            v-if="
              (!setTRPriceForReturnRoute && selectedRouteIndex === index) ||
              setTRPriceForReturnRoute
            "
          >
            <div class="partner-modal-info">
              <div class="info-content">
                <div class="info-row">
                  <h5 class="item-heading">Trip Info</h5>
                  <ul>
                    <li>
                      Route:
                      {{
                        requestRoute.route_name
                          ? requestRoute.route_name
                          : 'N/A'
                      }}
                    </li>
                    <li>
                      Trip Request ID:
                      {{
                        requestDetails.trip_code
                          ? requestDetails.trip_code
                          : 'N/A'
                      }}
                    </li>
                    <li>
                      Distance:
                      {{
                        requestRoute.distance
                          ? requestRoute.distance + 'KM'
                          : 'N/A'
                      }}
                    </li>
                    <li>
                      Trip Start Time:
                      {{
                        requestRoute.pick_up_times
                          ? vehicleRequest.pickUpTimes(
                              requestRoute.pick_up_times
                            )
                          : 'N/A'
                      }}
                    </li>
                    <li>
                      Duty Days:
                      {{
                        requestRoute.duty_days ? requestRoute.duty_days : 'N/A'
                      }}
                    </li>
                    <li>
                      Company:
                      {{
                        requestRoute.company_code
                          ? requestRoute.company_code
                          : 'N/A'
                      }}
                    </li>
                  </ul>
                </div>
                <div class="info-row">
                  <h5 class="item-heading">TR Price</h5>
                  <div class="row">
                    <div class="col-sm-7">
                      <ul>
                        <li v-if="requestRoute.modality !== 'fleet-variable'">
                          Daily Income (Without CB):
                          <span class="highlighted-list-text"
                            >{{
                              vehicleRequest.dailyIncomeWithShuttleBonus(
                                requestRoute.fare_per_km,
                                requestRoute.distance,
                                requestRoute.duty_days,
                                requestRoute.pick_up_times?.length,
                                vehicleRequest.shuttleBonusObjFromBonusArray(
                                  requestRoute.trip_request_bonuses,
                                  bonusObj
                                ).type,
                                vehicleRequest.shuttleBonusObjFromBonusArray(
                                  requestRoute.trip_request_bonuses,
                                  bonusObj
                                ).base_bonus
                              )
                            }}
                            TK</span
                          >
                        </li>
                        <li v-if="requestRoute.modality !== 'fleet-variable'">
                          Weekly Income (Without CB):
                          <span class="highlighted-list-text"
                            >{{
                              vehicleRequest.weeklyIncomeWithShuttleBonus(
                                requestRoute.fare_per_km,
                                requestRoute.distance,
                                requestRoute.duty_days,
                                requestRoute.pick_up_times?.length,
                                vehicleRequest.shuttleBonusObjFromBonusArray(
                                  requestRoute.trip_request_bonuses,
                                  bonusObj
                                ).type,
                                vehicleRequest.shuttleBonusObjFromBonusArray(
                                  requestRoute.trip_request_bonuses,
                                  bonusObj
                                ).base_bonus
                              )
                            }}
                            TK</span
                          >
                        </li>
                        <li v-if="requestRoute.modality !== 'fleet-variable'">
                          Weekly Income (With CB):
                          <span class="highlighted-list-text"
                            >{{
                              vehicleRequest.weeklyIncomeWithShuttleAndCompletionBonus(
                                requestRoute.fare_per_km,
                                requestRoute.distance,
                                requestRoute.duty_days,
                                requestRoute.pick_up_times?.length,
                                vehicleRequest.shuttleBonusObjFromBonusArray(
                                  requestRoute.trip_request_bonuses,
                                  bonusObj
                                ).type,
                                vehicleRequest.shuttleBonusObjFromBonusArray(
                                  requestRoute.trip_request_bonuses,
                                  bonusObj
                                ).base_bonus,
                                vehicleRequest.completionBonusFromBonusArray(
                                  requestRoute.trip_request_bonuses,
                                  bonusObj
                                )
                              )
                            }}
                            TK</span
                          >
                        </li>
                        <li>
                          Fare Per KM:
                          {{
                            requestRoute.fare_per_km
                              ? requestRoute.fare_per_km + 'TK'
                              : 'N/A'
                          }}
                        </li>
                        <li v-if="requestRoute.modality === 'fleet-variable'">
                          Body Rent:
                          {{
                            requestRoute.body_rent
                              ? requestRoute.body_rent + 'TK'
                              : 'N/A'
                          }}
                        </li>
                        <li v-if="requestRoute.modality === 'fleet-variable'">
                          Over Time/Hour Rate:
                          {{
                            requestRoute.overtime_payment_per_hour
                              ? requestRoute.overtime_payment_per_hour + 'TK'
                              : 'N/A'
                          }}
                        </li>
                        <li v-if="requestRoute.modality === 'fleet-variable'">
                          Lunch Allowance/Day:
                          {{
                            requestRoute.lunch_allowance_per_day
                              ? requestRoute.lunch_allowance_per_day + 'TK'
                              : 'N/A'
                          }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-sm-5">
                      <ul>
                        <li
                          v-for="(
                            bonus, bonusIndex
                          ) in requestRoute.trip_request_bonuses"
                          :key="bonusIndex"
                        >
                          {{
                            bonusObj[bonus.bonus_id]
                              ? bonusObj[bonus.bonus_id].bonus_name
                              : 'N/A Bonus'
                          }}: {{ bonus.base_bonus }}
                          {{ bonus.type === 'percentage' ? '%' : 'TK' }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ul>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="partner-modal-section">
          <h5 class="section-heading">Driver Price</h5>
          <div class="partner-form assign-driver-form">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="">Fare Per KM</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.fare_per_km"
                    :readonly="sameTRPriceOnDriverPrice"
                    required
                  />
                </div>
                <div
                  class="form-group"
                  v-if="
                    requestDetails.trip_request_routes &&
                    requestDetails.trip_request_routes[selectedRouteIndex]
                      ?.modality !== 'pool'
                  "
                >
                  <label for="">Body Rent</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.body_rent"
                    :readonly="sameTRPriceOnDriverPrice"
                    required
                  />
                </div>
                <!-- <div class="form-group">
                  <label for="">Completion Bonus</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div>
                <div class="form-group">
                  <label for="">Bonus Minute</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div> -->
              </div>
              <div class="col-sm-6">
                <div
                  class="form-group"
                  v-if="
                    requestDetails.trip_request_routes &&
                    requestDetails.trip_request_routes[selectedRouteIndex]
                      ?.modality === 'fleet-variable'
                  "
                >
                  <label for="">Over Time/Hour Rate</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.overtime_payment_per_hour"
                    :readonly="sameTRPriceOnDriverPrice"
                    required
                  />
                </div>
                <div
                  class="form-group"
                  v-if="
                    requestDetails.trip_request_routes &&
                    requestDetails.trip_request_routes[selectedRouteIndex]
                      ?.modality !== 'pool'
                  "
                >
                  <label for="">Lunch Allowance/Day</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.lunch_allowance_per_day"
                    :readonly="sameTRPriceOnDriverPrice"
                    required
                  />
                </div>
                <!-- <div class="form-group">
                  <label for="">Shuttle Bonus</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div>
                <div class="form-group">
                  <label for="">Bonus Amount</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div> -->
              </div>
            </div>
            <div class="form-group ad-checkbox-group">
              <input type="checkbox" v-model="sameTRPriceOnDriverPrice" />
              <span>Do you want the same TR Price on Driver price?</span>
            </div>
            <p class="highlighted-note">
              ***This price has no impact on TR Prices
            </p>
          </div>
        </div>
        <div class="partner-modal-section">
          <h5 class="section-heading">Search Driver</h5>
          <div class="partner-form">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Driver Phone Number"
                v-model="driverMobileNumber"
                required
                maxlength="11"
                pattern="[0-9]{11}"
                title="11 digit length containing only numbers!"
              />
            </div>
            <LoadingSpinner v-if="isLoadingDriver" size="50px"></LoadingSpinner>
            <div v-else class="driver-info-section">
              <div
                class="form-group"
                v-if="
                  driverMobileNumber?.length === 11 && driverList?.length <= 0
                "
              >
                <input
                  type="text"
                  class="form-control"
                  placeholder="New Driver Name"
                  v-model="driverName"
                  required
                />
              </div>
              <div
                v-for="(driver, index) in driverList"
                :key="index"
                class="partner-modal-info bordered-info-modal"
              >
                <div class="info-content">
                  <div class="info-row">
                    <h5 class="item-heading">Driver Info</h5>
                    <ul>
                      <li>Name: {{ driver.name }}</li>
                      <li>User Code: {{ driver.user_code }}</li>
                      <li>Phone Number: {{ driver.mobile }}</li>
                      <!-- <li>Role: Driver & Owner</li> -->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-group ad-checkbox-group ext-checkbox-group"
              v-if="
                requestDetails.trip_request_routes &&
                vehicleRequest.returnRoute(
                  requestDetails.trip_request_routes,
                  requestDetails.trip_request_routes[selectedRouteIndex]?.id
                ) &&
                vehicleRequest.returnRoute(
                  requestDetails.trip_request_routes,
                  requestDetails.trip_request_routes[selectedRouteIndex]?.id
                ).fare_per_km &&
                !vehicleRequest.returnRoute(
                  requestDetails.trip_request_routes,
                  requestDetails.trip_request_routes[selectedRouteIndex]?.id
                ).assigned_driver_details
              "
            >
              <input type="checkbox" v-model="setTRPriceForReturnRoute" />
              <span>Do you want to assign this driver for return route?</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-cancel"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">Assign Driver</button>
      </div>
    </form>
  </div>
</template>

<script>
import { vehicleRequest } from '@/store/vehicleRequest/vehicleRequest';
import userService from '@/config/axiosUserService';
import helpers from '@/store/helpers';
import http from '@/config/axios';
import LoadingSpinner from '../../UI/LoadingSpinner.vue';

export default {
  props: ['requestDetails', 'selectedRouteIndex', 'bonusObj'],
  components: {
    LoadingSpinner
  },
  data() {
    return {
      vehicleRequest,
      formValue: {
        fare_per_km: null,
        body_rent: null,
        overtime_payment_per_hour: null,
        lunch_allowance_per_day: null
      },
      sameTRPriceOnDriverPrice: false,
      setTRPriceForReturnRoute: false,
      driverMobileNumber: '',
      driverName: '',
      driverList: [],
      isLoading: false,
      isLoadingDriver: false,
      helpers
    };
  },
  watch: {
    requestDetails() {
      this.emptyFormValues();
    },
    selectedRouteIndex() {
      this.emptyFormValues();
    },
    sameTRPriceOnDriverPrice() {
      if (this.sameTRPriceOnDriverPrice) {
        this.formValue.fare_per_km =
          this.requestDetails.trip_request_routes[
            this.selectedRouteIndex
          ]?.fare_per_km;
        this.formValue.body_rent =
          this.requestDetails.trip_request_routes[
            this.selectedRouteIndex
          ]?.body_rent;
        this.formValue.overtime_payment_per_hour =
          this.requestDetails.trip_request_routes[
            this.selectedRouteIndex
          ]?.overtime_payment_per_hour;
        this.formValue.lunch_allowance_per_day =
          this.requestDetails.trip_request_routes[
            this.selectedRouteIndex
          ]?.lunch_allowance_per_day;
      } else {
        this.formValue.fare_per_km = null;
        this.formValue.body_rent = null;
        this.formValue.overtime_payment_per_hour = null;
        this.formValue.lunch_allowance_per_day = null;
      }
    },
    driverMobileNumber() {
      this.searchPartner();
    }
  },
  methods: {
    emptyFormValues() {
      this.formValue.fare_per_km = null;
      this.sameTRPriceOnDriverPrice = false;
      this.setTRPriceForReturnRoute = false;
      this.driverMobileNumber = '';
      this.driverName = '';
    },
    searchPartner() {
      this.driverList = [];

      if (this.driverMobileNumber && this.driverMobileNumber.length === 11) {
        if (
          !(
            this.helpers.containsAnyLetters(this.driverMobileNumber) ||
            this.helpers.hasWhiteSpace(this.driverMobileNumber)
          )
        ) {
          this.isLoadingDriver = true;
          let url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${this.driverMobileNumber}`;
          userService
            .get(url)
            .then((response) => {
              this.isLoadingDriver = false;
              this.driverList = response.data.data;
              if (this.driverList.length < 1) {
                this.$partnerSwal.warningToast.fire({
                  title: 'Warning!',
                  text: 'Driver not found!'
                });
              } else {
                this.driverName = '';
              }
            })
            .catch((error) => {
              this.isLoadingDriver = false;
              this.$partnerSwal.errorToast.fire({
                title: 'User Service Error!',
                text: error.response.data?.message
              });
            });
        } else {
          this.$partnerSwal.warningToast.fire({
            title: 'Warning!',
            text: 'Please enter a valid phone number!'
          });
        }
      } else if (
        this.driverMobileNumber &&
        this.driverMobileNumber.length >= 11
      ) {
        this.$partnerSwal.warningToast.fire({
          title: 'Warning!',
          text: 'Phone number can not be longer than 11 character!'
        });
      }
    },
    assignDriver() {
      if (
        this.driverList.length > 0 ||
        (this.driverMobileNumber?.length === 11 && this.driverName?.trim())
      ) {
        this.isLoading = true;
        let payload = {
          tripRequestId: this.requestDetails.id,
          tripRequestRouteId:
            this.requestDetails.trip_request_routes[this.selectedRouteIndex]
              ?.id,
          partnerCode:
            this.driverList?.length > 0 ? this.driverList[0].user_code : null,
          fare_per_km: this.formValue.fare_per_km,
          mobile: this.driverMobileNumber,
          name: this.driverName
        };

        if (
          this.requestDetails?.trip_request_routes[this.selectedRouteIndex]
            ?.modality !== 'pool'
        ) {
          payload.body_rent = this.formValue.body_rent;
          payload.lunch_allowance_per_day =
            this.formValue.lunch_allowance_per_day;
        }
        if (
          this.requestDetails?.trip_request_routes[this.selectedRouteIndex]
            ?.modality === 'fleet-variable'
        ) {
          payload.overtime_payment_per_hour =
            this.formValue.overtime_payment_per_hour;
        }

        http
          .post(
            `v2/partners/triprequestpartners?assign_same_partner_to_return_route=${
              this.setTRPriceForReturnRoute ? 1 : 0
            }`,
            payload
          )
          .then((response) => {
            this.isLoading = false;
            this.emptyFormValues();
            this.$emit('refreshData');
            this.$refs.modalCloseBtn.click();
            this.$partnerSwal.quickSuccessAlert.fire({
              title: 'Success!',
              text: response.data?.message
            });
          })
          .catch((error) => {
            this.isLoading = false;
            this.$partnerSwal.errorToast.fire({
              title: 'Error!',
              text: error.response.data?.message
            });
          });
      } else {
        this.$partnerSwal.warningToast.fire({
          title: 'Warning!',
          text: 'Please select a driver first!'
        });
      }
    }
  }
};
</script>

<style scoped>
.partner-modal-info .info-row {
  padding: 16px 0;
}
.partner-modal-info .info-row ul {
  margin-bottom: 0;
  padding-left: 0;
}
.partner-modal-info .info-row ul li {
  list-style: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 8px;
}
.partner-modal-info .info-row ul li:last-child {
  margin-bottom: 0;
}
.highlighted-list-text {
  font-weight: 500;
  color: #652f8f !important;
}
/* Form Design */
.assign-driver-form label {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
}
.form-group {
  margin-bottom: 12px;
}
.ad-checkbox-group {
  display: flex;
  align-items: center;
}
.ad-checkbox-group span {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
}
.highlighted-note {
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #1e40af;
}
.ext-checkbox-group {
  margin-top: 16px;
  margin-bottom: 0;
}
.bordered-info-modal {
  border: 1px solid #a95eea;
}
</style>
